import { Badge, Breadcrumb, Col, Dropdown, Layout, Menu, Row, Space } from "antd";
import dayjs from "dayjs";
import _, { cloneDeep, trim } from "lodash";
import { FC, ReactNode, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { menus } from "../../../commons/constants/menus";
import { routerNavigation, routers } from "../../../commons/constants/routers";
import { ArrowRight, Notification, TrifoodLogo } from "../../../commons/resources";
import { AppContext } from "../../../contexts/AppContext";
import { AppTencentContext } from "../../../contexts/ChatContext";
import AccountDropdown from "./AccountDropdown";
import "./custom-layout.module.scss";
import styles from "./custom-layout.module.scss";
import "./index.scss";
import { StoreExample } from "../../../commons/constants";
import { displayStoreId } from "../../../commons/utils/functions/shortText";
import { STORE_TYPE } from "../../../commons/constants/store";

const CustomLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const { currentStore, isMobile } = useContext(AppContext);
  const [collapsed, setCollapsed] = useState(isMobile);
  const { notifications, handleReadNotification, unreadNotifications } = useContext(AppTencentContext);
  const { pathname } = useLocation();
  const sideMenuRef = useRef<any>(null);

  const surplusTypeStore = currentStore && currentStore?.type === STORE_TYPE.SURPLUS;
  const foodDeliveryTypeStore = currentStore && currentStore?.type === STORE_TYPE.FOOD_DELIVERY;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (sideMenuRef.current && !sideMenuRef.current.contains(event.target)) {
        turnOffCollapse();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const isDetailChecking = pathname.split("/").length === 5 && pathname.includes("order-tracking");

  const handleViewAll = () => {
    navigate(routers.NOTIFICATION);
  };

  const turnOffCollapse = () => {
    if (!isMobile) return;
    setCollapsed(true);
  };

  const handleTitle = (item: any) => {
    const { content } = item;
    const { message } = content;
    let messageCLone = cloneDeep(message);
    const listKey = _.keys(content).filter(item => item !== "message");
    let res;
    if (listKey.length > 0) {
      res = listKey.reduce((message: string, value: string) => {
        return (message as string)?.replace(
          `:${value}`,
          `<span style="color:#fff ; font-weight: 600">${content[value]}</span>`
        );
      }, messageCLone);
    } else {
      res = message;
    }

    return {
      __html: `<div style="font-size: 14px; color: #ABABB1; font-weight: 400; cursor: pointer">${res}</div>`,
    };
  };

  function getActivePathName(pathname: string) {
    const orderTrackingPath = routerNavigation.STORES.ORDER_TRACKING(currentStore?.id ? currentStore?.id : "");
    if (pathname.startsWith(orderTrackingPath)) {
      return orderTrackingPath;
    }

    const refundManagement = routerNavigation.STORES.REFUND_MANAGEMENT(currentStore?.id ? currentStore?.id : "");
    if (pathname.startsWith(refundManagement)) {
      return refundManagement;
    }

    const rateManagement = routerNavigation.STORES.RATE_MANAGEMENT(currentStore?.id ? currentStore?.id : "");
    if (pathname.startsWith(rateManagement)) {
      return rateManagement;
    }

    const recon = routers.RECONCILIATION;
    if (pathname.startsWith(recon)) {
      return recon;
    }

    const campaign = routers.LP_MEMBER_SHIP.CAMPAIGN_LIST;
    if (pathname.startsWith("/lp-membership/campaign")) {
      return campaign;
    }

    return pathname;
  }

  const titleLevel2 = useMemo(() => {
    if (pathname === "/") {
      return null;
    } else if (pathname.includes(routers.LP_MEMBER_SHIP.LOYALTY_POINTS)) {
      return "Loyalty points transactions";
    } else if (pathname.includes("/lp-membership/campaign-detail")) {
      return "Campaign detail";
    } else if (pathname.includes("/rate/")) {
      return "Rating detail";
    } else {
      return "";
    }
  }, [pathname]);

  /**
   * For the second breadcrumb
   */
  const subTitle = useMemo(() => {
    if (pathname === "/") {
      return "Dashboard";
    }
    if (
      pathname.includes(routers.STORES.PRODUCT_MANAGEMENT.replace(":storeId", currentStore?.id as any)) ||
      pathname.includes(routers.STORES.CREATE_PRODUCT.replace(":storeId", currentStore?.id as any))
    ) {
      return "Product management";
      // }
      //  else if (pathname.includes(routers.STORES.MERCHANT_LANDING_PAGE.replace(":storeId", currentStore?.id as any))) {
      // return "Merchant Landing Page";
      // } else if (pathname.includes(routers.STORES.BADGE_MANAGEMENT.replace(":storeId", currentStore?.id as any))) {
      //   return "Badge Management";
      // } else if (pathname.includes(routers.STORES.CREATE_BADGE.replace(":storeId", currentStore?.id as any))) {
      //   return "Create new Badge";
    } else if (
      pathname.includes(routers.STORES.SURPLUS_MANAGEMENT.replace(":storeId", currentStore?.id as any)) ||
      pathname.includes(routers.STORES.CREATE_SURPLUS.replace(":storeId", currentStore?.id as any))
    ) {
      return "Surplus management";
    } else if (pathname.includes(routers.STORES.ORDER_TRACKING.replace(":storeId", currentStore?.id as any))) {
      return "Order Tracking";
    } else if (pathname.includes(routers.STORES.ORDER_TRACKING_DETAIL.replace(":storeId", currentStore?.id as any))) {
      return "Order Detail";

      // } else if (pathname.includes(routers.STORES.REFUND_MANAGEMENT.replace(":storeId", currentStore?.id as any))) {
      //   return "Refund Management";
    } else if (pathname.includes(routers.STORES.RATE_MANAGEMENT.replace(":storeId", currentStore?.id as any))) {
      return "Rate Management";
    } else if (pathname.includes(routers.STORES.CHAT_INBOX.replace(":storeId", currentStore?.id as any))) {
      return "Chat Inbox";
    } else if (pathname.includes(routers.STORES.REPORT.replace(":storeId", currentStore?.id as any))) {
      return "Report";
      // } else if (
      //   pathname.includes(routers.STORES.INVENTORY_MANAGEMENT.replace(":storeId", currentStore?.id as any)) ||
      //   pathname.includes("inventory-log")
      // ) {
      //   return "Inventory Management";
      // } else if (pathname.includes(routers.STORES.VOUCHER_LIST.replace(":storeId", currentStore?.id as any))) {
      //   return "Voucher list";
    } else if (pathname.includes(`/voucher/`) || pathname.includes("/edit-voucher/")) {
      return "Voucher detail";
    } else if (pathname.includes(routers.STORES.CREATE_VOUCHER.replace(":storeId", currentStore?.id as any))) {
      return "Voucher management";
    } else if (
      pathname.includes(routers.LP_MEMBER_SHIP.CAMPAIGN_LIST) ||
      pathname.includes(routers.LP_MEMBER_SHIP.CAMPAIGN_DETAIL)
    ) {
      return "Marketing Campaign";
    } else if (pathname.includes("/notification")) {
      return "Notifications";
    } else if (pathname.includes("/merchant-member")) {
      return "Merchant Member";
    } else if (pathname.includes("/membership")) {
      return "Membership";
    } else if (pathname.includes("account-information")) {
      return "Account Information";
    } else if (pathname.includes("settlement-report")) {
      return "Settlement Report";
    } else if (pathname.includes("group-menu")) {
      return "Group Menu";
    } else if (pathname.includes("order-setting")) {
      return "Order Setting";
    } else if (pathname.includes("voucher-list")) {
      return "Voucher List";
    } else {
      return "Store List";
    }
  }, [pathname, currentStore?.id]);

  /**
   * For the third breadcrumb
   */
  const subTitle2 = useMemo(() => {
    if (pathname.includes(routers.STORES.CREATE_PRODUCT.replace(":storeId", currentStore?.id as any))) {
      return "Add new product";
    } else if (pathname.includes(routers.STORES.CREATE_SURPLUS.replace(":storeId", currentStore?.id as any))) {
      return "Add new surplus";
    } else if (pathname.includes(routers.STORES.PRODUCT_MANAGEMENT.replace(":storeId", currentStore?.id as any))) {
      return "Food Delivery";
    } else if (pathname.includes(routers.STORES.SURPLUS_MANAGEMENT.replace(":storeId", currentStore?.id as any))) {
      return "Surplus";
    } else {
      return "";
    }
  }, [pathname, currentStore?.id]);

  let activePathName = getActivePathName(pathname);

  const countNotiPlus = useMemo(() => {
    if (!unreadNotifications) return null;
    if (unreadNotifications > 99) {
      return "99+";
    } else {
      return unreadNotifications;
    }
  }, [unreadNotifications]);

  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <Layout.Sider
        ref={sideMenuRef}
        onCollapse={() => {
          if (!isMobile) return;
          setCollapsed(cl => !cl);
        }}
        collapsed={collapsed}
        collapsible={isMobile}
        width={280}
        className={`${styles.slider_menu} ${isMobile && "is-mobile"}`}
        collapsedWidth={0}
        breakpoint="md"
      >
        <Link to={routers.DASHBOARD} className={styles.logoLink}>
          <TrifoodLogo width="auto" height={40} onClick={turnOffCollapse} />
        </Link>
        <Menu
          className="side__menu"
          theme="dark"
          mode="inline"
          selectedKeys={[activePathName]}
          defaultOpenKeys={[routers.STORES.LIST]}
          style={{ height: "calc(100% - 80px)", overflow: "auto" }}
          items={menus
            .filter(value => {
              if (currentStore.name === StoreExample.name && value.isStore) {
                return false;
              }
              return true;
            })
            .map(({ isStore, path, icon: Icon, label, hasNotify, children, count, renderPath }) => {
              if (children && path === routers.LP_MEMBER_SHIP.INFO) {
                return {
                  key: path,
                  path: path,
                  label: (
                    <Link to={path} onClick={turnOffCollapse}>
                      <span>{label}</span>
                      {hasNotify && <span className={styles.menuItemCount}>{count || 0}</span>}
                    </Link>
                  ),
                  icon: <Icon />,
                  children: children.map(item => ({
                    key: item.path,
                    path: item.path,
                    label: (
                      <Menu.Item>
                        <Link onClick={turnOffCollapse} to={item.path}>
                          {item.label}
                        </Link>
                      </Menu.Item>
                    ),
                  })),
                };
              }
              if (!isStore || !children) {
                return {
                  key: (currentStore && renderPath?.(currentStore?.id)) || path,
                  path: (currentStore && renderPath?.(currentStore?.id)) || path,
                  label: (
                    <Link to={(currentStore && renderPath?.(currentStore?.id)) || path} onClick={turnOffCollapse}>
                      <span>{label}</span>
                      {path === routers.NOTIFICATION && hasNotify && countNotiPlus && (
                        <span className={styles.menuItemCount}>{countNotiPlus}</span>
                      )}
                    </Link>
                  ),
                  icon: <Icon />,
                };
              }

              return {
                key: (currentStore && renderPath?.(currentStore?.id)) || path,
                path: (currentStore && renderPath?.(currentStore?.id)) || path,
                label: (
                  <Link to={(currentStore && renderPath?.(currentStore?.id)) || path}>
                    <span>{isStore ? `${trim(currentStore.name)}` : label}</span>
                    {/* {hasNotify && <span className={styles.menuItemCount}>{count || 0}</span>} */}
                  </Link>
                ),
                icon: <Icon />,
                children: children.map(item => {
                  if (item.path === routers.STORES.PRODUCT_MANAGEMENT && !foodDeliveryTypeStore) {
                    return undefined;
                  }
                  if (item.path === routers.STORES.SURPLUS_MANAGEMENT && !surplusTypeStore) {
                    return undefined;
                  }
                  return {
                    key: (currentStore && item.renderPath?.(currentStore?.id)) || item.path,
                    path: (currentStore && item.renderPath?.(currentStore?.id)) || item.path,
                    label: (
                      <Menu.Item style={{ paddingLeft: 20 }}>
                        <Link
                          to={(currentStore && item.renderPath?.(currentStore?.id)) || item.path}
                          onClick={turnOffCollapse}
                        >
                          {item.label}
                        </Link>
                      </Menu.Item>
                    ),
                    children: item.children
                      ? item.children.map(child => ({
                          key: "child" + (currentStore && child.renderPath?.(currentStore?.id)) || child.path,
                          path: (currentStore && child.renderPath?.(currentStore?.id)) || child.path,
                          label: (
                            <Menu.Item style={{ paddingLeft: 20 }}>
                              <Link
                                to={(currentStore && child.renderPath?.(currentStore?.id)) || child.path}
                                onClick={turnOffCollapse}
                              >
                                {child.label}
                              </Link>
                            </Menu.Item>
                          ),
                        }))
                      : undefined,
                  };
                }),
              };
            })}
        />
      </Layout.Sider>
      <Layout>
        {!collapsed && isMobile && <div className="sidemenu__masker"></div>}
        <Layout.Header className={styles.header}>
          {!isMobile && (
            <Breadcrumb separator="" className={styles.breadcrumb_cover}>
              {Number(displayStoreId(currentStore?.id)) > 1 ? (
                <>
                  <Breadcrumb.Item href={routers.STORES.LIST}>Store</Breadcrumb.Item>
                  <Breadcrumb.Separator>
                    <ArrowRight />
                  </Breadcrumb.Separator>
                </>
              ) : (
                <>
                  {titleLevel2 && (
                    <>
                      <Breadcrumb.Separator>
                        <ArrowRight />
                      </Breadcrumb.Separator>
                      {titleLevel2}
                    </>
                  )}
                </>
              )}

              <Breadcrumb.Item>{subTitle}</Breadcrumb.Item>
              {/* {subTitle && currentStore?.id && (
                <Breadcrumb.Separator>
                  <ArrowRight />
                </Breadcrumb.Separator>
              )} */}
              {/* {currentStore?.id && <Breadcrumb.Item>{subTitle}</Breadcrumb.Item>} */}
              {isDetailChecking && (
                <>
                  {" "}
                  <Breadcrumb.Separator>
                    <ArrowRight />
                  </Breadcrumb.Separator>{" "}
                  <Breadcrumb.Item>Order Details</Breadcrumb.Item>{" "}
                </>
              )}

              {subTitle && subTitle === "Marketing Campaign" && (
                <>
                  {" "}
                  <Breadcrumb.Separator>
                    <ArrowRight />
                  </Breadcrumb.Separator>{" "}
                  <Breadcrumb.Item>{subTitle}</Breadcrumb.Item>{" "}
                </>
              )}

              {subTitle2 && (
                <>
                  {" "}
                  <Breadcrumb.Separator>
                    <ArrowRight />
                  </Breadcrumb.Separator>{" "}
                  <Breadcrumb.Item>{subTitle2}</Breadcrumb.Item>{" "}
                </>
              )}
            </Breadcrumb>
          )}

          <Space size={30} className={`header_right ${isMobile && "is-mobile"}`}>
            <Dropdown
              trigger={["hover"]}
              overlay={
                <div className={"dropdownNoti"}>
                  {notifications.map(item => {
                    return (
                      <Row
                        key={item.id}
                        className="item"
                        onClick={() => handleReadNotification(item)}
                        style={!dayjs(item.read_at).isValid() ? {} : { opacity: 0.6 }}
                      >
                        <Col span={23} className={"record"}>
                          <div dangerouslySetInnerHTML={handleTitle(item)} />
                          <div className="date">{dayjs(item?.notify_at).format("DD/MM/YYYY HH:mm")}</div>
                        </Col>
                        <Col span={1} className="badge">
                          <div>{!dayjs(item.read_at).isValid() && <Badge key={"blue"} color={"#F4E85B"} />}</div>
                        </Col>
                      </Row>
                    );
                  })}
                  <div className="viewAll" onClick={handleViewAll}>
                    View all notifications
                  </div>
                </div>
              }
              placement="bottomRight"
              overlayClassName="dropdown-wrapper"
            >
              <Badge count={unreadNotifications} className="header_noti">
                <Notification />
              </Badge>
            </Dropdown>
            {isMobile && (
              <Link to={routers.DASHBOARD} className={styles.logoLink}>
                <TrifoodLogo width="auto" height={40} />
              </Link>
            )}
            <AccountDropdown />
          </Space>
        </Layout.Header>
        <Layout.Content className={styles.main}>{children}</Layout.Content>
      </Layout>
    </Layout>
  );
};

export default CustomLayout;
